/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ReassignBidderConflictType {
  AlreadyAssigned = 'already_assigned',
  TargetUserNotFound = 'target_user_not_found',
  TargetAlreadyHasPrimaryBidderForAuction = 'target_already_has_primary_bidder_for_auction'
}
